import React, {useEffect, useState} from 'react';
import {differenceWith, isEmpty} from 'lodash';
import {useDispatch, useSelector} from 'react-redux';
import LabeledSelect from '../../../components/selects/LabeledSelect';
import UserInfoSearchSelect from './SearchBar';
import Input from '../../../components/form/Input';
import JobCardLoader from "./JobCardLoader";
import {getCampaignInfo, getShifts, getUserBookedShift} from "../../../redux/slices/nurseCampaignSlice";
import {utcToLocalTimeString} from "../../../helpers/dateTimeHelper";
import {isCampaignAddressValid} from './CampaignsJobs';

const BookCampaignForm = ({
                            showMap,
                            setBookings,
                            booking,
                            setSelectedUser,
                            addressList,
                            setAddressList,
                            campaignId
                          }) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(undefined);
  const [selectedDate, setSelectedDate] = useState('');
  const [availableShift, setAvailableShift] = useState([]);

  const {
    shiftList,
    disabledShift,
    campaignInfo,
    loadingCampaignInfo,
    campaignInfoError,
    shiftListError,
    loadingShiftList,
    bookedShift,
    bookedShiftError
  } = useSelector((state) => state.campaign);

  useEffect(() => {
    setUser(undefined);
  }, []);

  useEffect(() => {
    if (!isEmpty(bookedShiftError)) {
      setUser(undefined)
      setSelectedUser({})
    }
  }, [bookedShiftError])

  useEffect(() => {
    //filter booked shift of particular user based on selected date
    const filteredShift = bookedShift.filter((data) => data.appointment_date === selectedDate.value);
    //remove unavailable shift and disable shift that user has already booked
    setAvailableShift(booking?.appointment_date?.length === 0 || booking?.appointment_date === undefined
      ? []
      : differenceWith(
        shiftList.filter((shift) => !shift.disabled),
        disabledShift,
        (shift, disabledShift) =>
          shift?.id === disabledShift?.shift &&
          booking?.appointment_date.value === disabledShift.date
      ).map((data) =>
        filteredShift.find((filteredShift) => filteredShift.shift_id === data.id) ? {
          ...data,
          isDisabled: true
        } : data));
  }, [selectedDate]);

  useEffect(() => {
    if (user) {
      const filteredAddressWithArea = user.address.filter((add) => add.area && add.city && add.province && add.landmark);
      let defaultAddress = filteredAddressWithArea.find(
        (address) => address.default_address
      );
      setBookings({address: defaultAddress , userId: user?.id}, booking);
      //set default address initially
      setAddressList(filteredAddressWithArea);
    }
  }, [user]);

  const getBookedShift = (id) => {
    dispatch(getUserBookedShift({campaignId, patientId: id}));
  };

  return (
    <div>
      {loadingCampaignInfo || isEmpty(campaignInfo) || !isEmpty(campaignInfoError) || loadingShiftList || isEmpty(shiftList) || !isEmpty(shiftListError) ? (
        <JobCardLoader
          count={1}
          height="h-20"
          loading={loadingCampaignInfo || loadingShiftList}
          error={shiftListError || campaignInfoError}
          isEmpty={isEmpty(campaignInfo) || isEmpty(shiftList)}
          retry={() => {
            dispatch(getShifts(campaignId));
            dispatch(getCampaignInfo(campaignId));
          }}
        />) : (
        <div>

          <div className="flex space-x-6">
            <UserInfoSearchSelect
              label="Phone Number"
              onChange={(user) => {
                setSelectedUser(user);
                setUser(user);
                //get user booked shifts
                // getBookedShift(user.mobile);
                getBookedShift(user.id);
              }}
              value={user}
            />
            <Input
              type="number"
              color="blue"
              placeholder="Quantity"
              value={booking?.quantity ?? ''}
              onChange={(e) => {
                setBookings({quantity: e.target.value}, booking);
              }}
            />

          </div>
          {user && (
            <div>
              <div className="flex justify-between mb-2">
                <label className="text-sm font-semibold" htmlFor="Shipping address*">Shipping Address</label>
                <span className="link" onClick={() => showMap(true)}>+ Add address</span>
              </div>
              <LabeledSelect
                placeholder="Shipping Address"
                getOptionValue={(option) => option?.id}
                getOptionLabel={(option) => `${option.area?.name}, ${option.city?.name}, ${option.province?.name} `}
                onChange={(address) => {
                  setBookings({address: address}, booking)
                }}
                options={addressList}
                value={booking?.address}
              />
              {
                (!isCampaignAddressValid(booking.address)) ? <div className='pb-3 text-sm text-error-500'>Campaign is not available in this area</div> :
            ""
            }
            </div>
          )}

          <div className="flex space-x-6">
            <LabeledSelect
              label="Appointment Date"
              getOptionLabel={(option) => option.value}
              placeholder="Appointment Date"
              onChange={(date) => {

                setBookings({appointment_date: date, shift: undefined}, booking);
                setSelectedDate(date);

              }}
              options={campaignInfo?.date
                ?.map(option => {
                  return {value: option};
                })
              }
              value={booking?.appointment_date}
            />

            <LabeledSelect
              label="Appointment Time"
              placeholder={
                booking?.appointment_date?.length === 0 || booking?.appointment_date === undefined
                  ? 'Please select a date first'
                  : 'Select...'
              }
              onChange={(slot) => {
                setBookings({shift: slot}, booking);
              }}
              getOptionValue={(option) => option?.id}
              getOptionLabel={(option) => `${option?.name} [${utcToLocalTimeString(option?.start_time)}-${utcToLocalTimeString(option?.end_time)}]`}
              options={availableShift}
              value={booking?.shift}
            />

          </div>
        </div>
      )
      }
    </div>
  );
};

export default BookCampaignForm;
